/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SideBarMenu from './lib/side';
import Header from './lib/header';
import { getCurrentToken, onMessageListener } from '../../../firebase';
import { useActions } from 'common/hooks/useActions';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { notification } from 'antd';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import Cookies from 'js-cookie';
import { Crypto } from 'common/helpers/crypto';
import AppLoading from 'components/appLoading';
import { PageTitleProvider } from 'components/pageTitle';

import * as S from './styles';

/** Below this the rail cannot hold a label, so it collapses to icons. */
const NARROW = '(max-width: 1100px)';

export default function PanelLayout() {
  const history = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const userInfo = Cookies.get('userInfo') ? JSON.parse(Crypto.decrypt(Cookies.get('userInfo'))) : '';

  const { notifications }: any = useTypedSelector((state: any) => state.Notifications);
  const { logOut }: any = useTypedSelector((state: any) => state.Authenticate);

  const { addOrUpdateFirebaseTokenRequestAction, notificationsRequestAction } = useActions();

  /**
   * The rail collapses below 1100px and can be collapsed by hand at any width.
   * Crossing the breakpoint resets it to that width's default, which keeps the
   * two inputs from arguing with each other.
   */
  const [collapsed, setCollapsed] = useState(() => window.matchMedia(NARROW).matches);

  useEffect(() => {
    const query = window.matchMedia(NARROW);
    const onChange = (event: MediaQueryListEvent) => setCollapsed(event.matches);

    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    if (location.pathname === '/panel') history('/panel/dashboard');
  }, [history, location.pathname]);

  useEffect(() => {
    onMessageListener()
      .then((payload: any) => {
        console.log('New Notification', payload);
        notificationsRequestAction();
        // setShow(true);
        // setNotification({ title: payload.notification.title, body: payload.notification.body })
        // toast({ message: payload.notification.title + " - " + payload.notification.body, position: "top-right" })
        const args = {
          message: payload.notification.title,
          description: payload.notification.body,
          duration: 0
        };
        notification.open(args);
      })
      .catch((err: any) => console.log('failed: ', err));
    notificationsRequestAction();
  }, []);

  useEffect(() => {
    getCurrentToken((fcm_token: string) => {
      addOrUpdateFirebaseTokenRequestAction(fcm_token, () => {
        console.log(fcm_token);

        // if (localStorage.getItem('customFirebaseToken')) {
        //   handleSigninFirebaseCustom(localStorage.getItem('customFirebaseToken') as string);
        // } else {
        //   getFirebaseTokenRequestAction((custom_token: string) => {
        //     handleSigninFirebaseCustom(custom_token);
        //   });
        // }
      });
    });
  }, []);

  // not currently wired up; kept for the firebase custom-token sign-in flow
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSigninFirebaseCustom = (token: string) => {
    signInWithCustomToken(auth, token)
      .then((_userCredential) => {})
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log('firebase error: ', errorCode, errorMessage);
        if (errorCode === 'auth/invalid-custom-token') {
          console.log('The token you provided is not valid.');
        } else {
          console.error(error);
        }
      });
  };

  return (
    <PageTitleProvider>
      <S.Container>
        <SideBarMenu userInfo={userInfo} collapsed={collapsed} onExpand={() => setCollapsed(false)} />
        <S.Main>
          <Header
            notifications={notifications.data}
            userInfo={userInfo}
            onToggleSidebar={() => setCollapsed((value) => !value)}
          />
          <S.Content>
            <Outlet />
          </S.Content>
        </S.Main>
        <AppLoading loading={logOut.loading} />
      </S.Container>
    </PageTitleProvider>
  );
}
